<div class="grid mb-3">
	<div class="col-12 flex align-items-center justify-content-center bg-yellow-200 py-1 border-round-xl">
		<i class="pi cm-alert text-2xl text-yellow-700 mx-2"></i>
		<p-tag [value]="('MTMA_CONTROL_ACCESS_WARNING' | translate)" severity="warning"></p-tag>
	</div>
</div>
<p-accordion>
	<app-mtma-control-access-group-easy-list></app-mtma-control-access-group-easy-list>
	<app-mtma-control-access-weekly-schedule-list></app-mtma-control-access-weekly-schedule-list>
	<app-mtma-control-access-special-planning-list></app-mtma-control-access-special-planning-list>
</p-accordion>